(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-project-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root, signal) {
      root.querySelectorAll('[data-rwx-compare]').forEach(function (frame) {
        var range = frame.querySelector('input');
        var set = function (v) {
          v = Math.max(0, Math.min(100, v));
          frame.style.setProperty('--pos', v + '%');
          range.value = v;
        };
        var fromPointer = function (e) {
          var r = frame.getBoundingClientRect();
          set(((e.clientX - r.left) / r.width) * 100);
        };
        range.addEventListener('input', function () { set(Number(range.value)); }, { signal: signal });
        frame.addEventListener('pointerdown', function (e) {
          frame.setPointerCapture(e.pointerId);
          fromPointer(e);
        }, { signal: signal });
        frame.addEventListener('pointermove', function (e) {
          if (frame.hasPointerCapture(e.pointerId)) fromPointer(e);
        }, { signal: signal });
      });
    }

    var controllers = new Map();
    function mount(root) {
      var c = new AbortController();
      controllers.set(root, c);
      init(root, c.signal);
    }
    document.querySelectorAll('.rwx-pp').forEach(mount);
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('.rwx-pp');
      if (root) mount(root);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector('.rwx-pp');
      if (root && controllers.has(root)) { controllers.get(root).abort(); controllers.delete(root); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-service-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var SELECTOR = '[data-rwx-sp-videos]';

    function init(root, signal) {
      var videos = Array.prototype.slice.call(root.querySelectorAll('[data-rwx-sp-video]'));
      var btn = root.querySelector('[data-rwx-sp-pause]');
      var label = btn && btn.querySelector('[data-rwx-sp-pause-label]');
      var icon = btn && btn.querySelector('.rwx-sp__pause-icon');
      var visible = false;
      // Paused by the visitor (button) or by the reduced-motion setting; otherwise plays while on screen.
      var userPaused = reduce.matches;
      function render() {
        if (!label || !icon) return;
        label.textContent = userPaused ? btn.dataset.labelPlay : btn.dataset.labelPause;
        icon.textContent = userPaused ? '▶' : '❚❚';
      }
      function sync() {
        videos.forEach(function (video) {
          if (userPaused || !visible) video.pause();
          else video.play().catch(function () {});
        });
      }
      if (btn) btn.addEventListener('click', function () { userPaused = !userPaused; render(); sync(); }, { signal: signal });
      reduce.addEventListener('change', function () { userPaused = reduce.matches; render(); sync(); }, { signal: signal });
      var observer = new IntersectionObserver(function (entries) {
        visible = entries[entries.length - 1].isIntersecting;
        sync();
      });
      observer.observe(root);
      signal.addEventListener('abort', function () { observer.disconnect(); });
      render();
    }

    var controllers = new WeakMap();
    function mount(scope) {
      scope.querySelectorAll(SELECTOR).forEach(function (root) {
        if (controllers.has(root)) return;
        var controller = new AbortController();
        controllers.set(root, controller);
        init(root, controller.signal);
      });
    }
    function unmount(scope) {
      scope.querySelectorAll(SELECTOR).forEach(function (root) {
        var controller = controllers.get(root);
        if (controller) { controller.abort(); controllers.delete(root); }
      });
    }

    mount(document);
    document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { unmount(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-x-car"]) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var SELECTOR = '[data-rwx-car]';

    function init(root, signal) {
      var track = root.querySelector('.rwx-car__track');
      if (!track || !track.children.length) return;
      var slides = track.children;
      var current = root.querySelector('[data-car-current]');
      var arrows = root.querySelectorAll('[data-car-dir]');
      var thumbs = root.querySelectorAll('[data-car-go]');
      var index = -1;

      // One step = slide width + gap (slides are 100% wide on desktop, 88% on phones).
      function step() {
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return slides[0].getBoundingClientRect().width + gap;
      }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * step(), behavior: reduce.matches ? 'auto' : 'smooth' });
      }
      function sync() {
        var i = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / step())));
        if (i === index) return;
        index = i;
        if (current) current.textContent = String(i + 1).padStart(2, '0');
        if (arrows.length === 2) {
          arrows[0].disabled = i === 0;
          arrows[1].disabled = i === slides.length - 1;
        }
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-active', n === i);
          if (n === i) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
        });
        // Keep the active thumbnail in view by scrolling the strip sideways only (never the page).
        var active = thumbs[i], strip = active && active.closest('.rwx-car__thumbs');
        if (strip) {
          var a = active.getBoundingClientRect(), b = strip.getBoundingClientRect();
          if (a.left < b.left) strip.scrollLeft -= b.left - a.left;
          else if (a.right > b.right) strip.scrollLeft += a.right - b.right;
        }
      }
      var queued = false;
      function onScroll() {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () { queued = false; sync(); });
      }
      arrows.forEach(function (b) { b.addEventListener('click', function () { go(index + Number(b.dataset.carDir)); }, { signal: signal }); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.dataset.carGo)); }, { signal: signal }); });
      track.addEventListener('scroll', onScroll, { passive: true, signal: signal });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      }, { signal: signal });
      sync();
    }

    var controllers = new WeakMap();
    function mount(scope) {
      scope.querySelectorAll(SELECTOR).forEach(function (root) {
        if (controllers.has(root)) return;
        var controller = new AbortController();
        controllers.set(root, controller);
        init(root, controller.signal);
      });
    }
    function unmount(scope) {
      scope.querySelectorAll(SELECTOR).forEach(function (root) {
        var controller = controllers.get(root);
        if (controller) controller.abort();
        controllers.delete(root);
      });
    }
    mount(document);
    document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { unmount(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-x-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root, signal) {
      var box = root.querySelector('[data-rwx-photos]');
      if (!box) return;
      var form = box.closest('form');
      var input = box.querySelector('.rwx-photos__input');
      var list = box.querySelector('.rwx-photos__list');
      var status = box.querySelector('.rwx-photos__status');
      var hidden = box.querySelector('input[type="hidden"]');
      var t = box.dataset;
      var max = Number(t.max);
      var items = [];

      var sync = function () {
        hidden.value = items.filter(function (i) { return i.url; }).map(function (i) { return i.url; }).join('\n');
        box.classList.toggle('is-full', items.length >= max);
      };

      var add = function (file) {
        var item = { url: '', pending: true };
        var li = document.createElement('li');
        li.className = 'rwx-photos__item';
        var img = document.createElement('img');
        img.alt = '';
        img.src = URL.createObjectURL(file);
        var text = document.createElement('span');
        text.className = 'rwx-photos__text';
        var name = document.createElement('span');
        name.className = 'rwx-photos__name';
        name.textContent = file.name;
        var state = document.createElement('span');
        state.className = 'rwx-meta rwx-photos__state';
        text.append(name, state);
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'rwx-meta rwx-photos__remove';
        remove.textContent = t.tRemove;
        remove.setAttribute('aria-label', t.tRemove + ': ' + file.name);
        li.append(img, text, remove);
        list.append(li);
        items.push(item);

        remove.addEventListener('click', function () {
          item.removed = true;
          items.splice(items.indexOf(item), 1);
          URL.revokeObjectURL(img.src);
          li.remove();
          sync();
          input.focus();
        }, { signal: signal });

        if (file.size > Number(t.maxMb) * 1024 * 1024) {
          item.pending = false;
          li.classList.add('is-error');
          state.textContent = t.tBig;
          sync();
          return;
        }

        state.textContent = t.tUploading;
        var data = new FormData();
        data.append('file', file);
        data.append('upload_preset', t.preset);
        fetch('https://api.cloudinary.com/v1_1/' + encodeURIComponent(t.cloud) + '/image/upload', { method: 'POST', body: data, signal: signal })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function (json) {
            item.pending = false;
            if (item.removed) return;
            item.url = json.secure_url;
            state.textContent = t.tDone;
            sync();
          })
          .catch(function () {
            item.pending = false;
            if (item.removed) return;
            li.classList.add('is-error');
            state.textContent = t.tError;
          });
        sync();
      };

      input.addEventListener('change', function () {
        Array.prototype.slice.call(input.files, 0, Math.max(0, max - items.length)).forEach(add);
        input.value = '';
      }, { signal: signal });

      form.addEventListener('submit', function (e) {
        if (items.some(function (i) { return i.pending; })) {
          e.preventDefault();
          status.textContent = t.tWait;
        }
      }, { signal: signal });
    }

    var controllers = new Map();
    function mount(root) {
      var c = new AbortController();
      controllers.set(root, c);
      init(root, c.signal);
    }
    document.querySelectorAll('#contact').forEach(mount);
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('#contact');
      if (root) mount(root);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector('#contact');
      if (root && controllers.has(root)) { controllers.get(root).abort(); controllers.delete(root); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-x-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var SELECTOR = '[data-rwx-hero-video]';

    function init(video, signal) {
      var root = video.closest('.rwx-hero');
      var btn = root && root.querySelector('[data-rwx-hero-pause]');
      var label = btn && btn.querySelector('[data-rwx-hero-pause-label]');
      var icon = btn && btn.querySelector('.rwx-hero__pause-icon');
      // Paused by the visitor (button) or by the reduced-motion setting; otherwise keep the loop running.
      var userPaused = reduce.matches;
      function render() {
        if (!label || !icon) return;
        label.textContent = userPaused ? btn.dataset.labelPlay : btn.dataset.labelPause;
        icon.textContent = userPaused ? '\u25B6' : '\u275A\u275A';
      }
      function keepPlaying() {
        if (userPaused) { video.pause(); return; }
        if (video.paused) video.play().catch(function () {});
      }
      if (btn) btn.addEventListener('click', function () { userPaused = !userPaused; render(); keepPlaying(); }, { signal: signal });
      // Restart it if the browser pauses it (tab switch, power saving), unless the visitor paused it.
      video.addEventListener('pause', function () { if (!document.hidden && !userPaused) keepPlaying(); }, { signal: signal });
      document.addEventListener('visibilitychange', function () { if (!document.hidden) keepPlaying(); }, { signal: signal });
      reduce.addEventListener('change', function () { userPaused = reduce.matches; render(); keepPlaying(); }, { signal: signal });
      render();
      keepPlaying();
    }

    var controllers = new WeakMap();
    function mount(scope) {
      scope.querySelectorAll(SELECTOR).forEach(function (root) {
        if (controllers.has(root)) return;
        var controller = new AbortController();
        controllers.set(root, controller);
        init(root, controller.signal);
      });
    }
    function unmount(scope) {
      scope.querySelectorAll(SELECTOR).forEach(function (root) {
        var controller = controllers.get(root);
        if (controller) controller.abort();
        controllers.delete(root);
      });
    }
    mount(document);
    document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { unmount(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-x-instagram"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Instafeed has no filter for trial reels, so posts listed in "Hidden posts" are dropped here,
    // and the grid is trimmed to full rows so no gap is left behind.
    var SELECTOR = '[data-rwx-insta-feed]';

    function init(root, signal) {
      var hidden = (root.dataset.hidden || '').split(',').filter(Boolean);
      function apply() {
        var items = Array.prototype.slice.call(root.querySelectorAll('.instafeed-new-layout-item'));
        if (!items.length) return;
        var shown = items.filter(function (item) {
          var opener = item.querySelector('[data-instafeed-open-id]');
          var id = opener ? opener.getAttribute('data-instafeed-open-id').replace('-insta-feed', '') : '';
          var keep = hidden.indexOf(id) === -1;
          item.style.display = keep ? '' : 'none';
          return keep;
        });
        var grid = items[0].parentElement;
        var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').length || 1;
        var full = shown.length > cols ? shown.length - (shown.length % cols) : shown.length;
        shown.forEach(function (item, i) { if (i >= full) item.style.display = 'none'; });
      }
      var observer = new MutationObserver(apply);
      observer.observe(root, { childList: true, subtree: true });
      signal.addEventListener('abort', function () { observer.disconnect(); });
      window.addEventListener('resize', apply, { signal: signal });
      apply();
    }

    var controllers = new WeakMap();
    function mount(scope) {
      scope.querySelectorAll(SELECTOR).forEach(function (root) {
        if (controllers.has(root)) return;
        var controller = new AbortController();
        controllers.set(root, controller);
        init(root, controller.signal);
      });
    }
    function unmount(scope) {
      scope.querySelectorAll(SELECTOR).forEach(function (root) {
        var controller = controllers.get(root);
        if (controller) { controller.abort(); controllers.delete(root); }
      });
    }

    mount(document);
    document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { unmount(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-x-listings"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var SELECTOR = '[data-rwx-cars]';

    function init(root, signal) {
      var track = root.querySelector('.rwx-listings--carousel');
      var nav = root.querySelector('.rwx-listings__nav');
      if (!track || !nav) return;
      var buttons = nav.querySelectorAll('.rwx-listings__btn');
      if (buttons.length !== 2) return;
      // One click = one card; buttons disable at the ends and hide when nothing scrolls.
      function step() {
        var card = track.querySelector('li');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 1;
        nav.hidden = max <= 0;
        buttons[0].disabled = track.scrollLeft <= 0;
        buttons[1].disabled = track.scrollLeft >= max;
      }
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          track.scrollBy({ left: step() * Number(btn.dataset.dir), behavior: reduce.matches ? 'auto' : 'smooth' });
        }, { signal: signal });
      });
      track.addEventListener('scroll', sync, { passive: true, signal: signal });
      var observer = new ResizeObserver(sync);
      observer.observe(track);
      signal.addEventListener('abort', function () { observer.disconnect(); });
      sync();
    }

    var controllers = new WeakMap();
    function mount(scope) {
      scope.querySelectorAll(SELECTOR).forEach(function (root) {
        if (controllers.has(root)) return;
        var controller = new AbortController();
        controllers.set(root, controller);
        init(root, controller.signal);
      });
    }
    function unmount(scope) {
      scope.querySelectorAll(SELECTOR).forEach(function (root) {
        var controller = controllers.get(root);
        if (controller) controller.abort();
        controllers.delete(root);
      });
    }
    mount(document);
    document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { unmount(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-x-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var SELECTOR = '[data-rwx-reviews]';

    function init(root, signal) {
      var track = root.querySelector('.rwx-reviews__track');
      var nav = root.querySelector('.rwx-reviews__nav');
      var buttons = root.querySelectorAll('.rwx-reviews__btn');
      if (!track || !nav || buttons.length !== 2) return;

      // Prev/next move by one card; buttons disable at the ends and hide when nothing scrolls.
      function step() {
        var card = track.querySelector('.rwx-review');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 1;
        nav.hidden = max <= 0;
        buttons[0].disabled = track.scrollLeft <= 0;
        buttons[1].disabled = track.scrollLeft >= max;
      }
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          track.scrollBy({ left: step() * Number(btn.dataset.dir), behavior: reduce.matches ? 'auto' : 'smooth' });
        }, { signal: signal });
      });
      track.addEventListener('scroll', sync, { passive: true, signal: signal });

      // "Read more" only on cards whose text is actually clamped.
      function clamp() {
        root.querySelectorAll('.rwx-review').forEach(function (card) {
          var more = card.querySelector('.rwx-review__more');
          var text = card.querySelector('.rwx-review__text:not([hidden]) p');
          if (!more || !text || card.classList.contains('is-open')) return;
          more.hidden = text.scrollHeight <= text.clientHeight + 1;
        });
        sync();
      }
      root.querySelectorAll('.rwx-review__more').forEach(function (more) {
        more.addEventListener('click', function () {
          var open = more.closest('.rwx-review').classList.toggle('is-open');
          more.setAttribute('aria-expanded', String(open));
          more.textContent = open ? more.dataset.less : more.dataset.more;
        }, { signal: signal });
      });

      // English site: the translation shows first; the button swaps in the author's original words.
      root.querySelectorAll('[data-rwx-lang-toggle]').forEach(function (btn) {
        var box = btn.closest('.rwx-review, .rwx-feature');
        if (!box) return;
        var mark = box.querySelector('.rwx-feature__mark');
        btn.hidden = false;
        btn.addEventListener('click', function () {
          var original = btn.dataset.state !== 'original';
          box.querySelectorAll('[data-rwx-tr]').forEach(function (el) { el.hidden = original; });
          box.querySelectorAll('[data-rwx-orig]').forEach(function (el) { el.hidden = !original; });
          if (mark) mark.textContent = original ? '\u201E' : '\u201C';
          btn.dataset.state = original ? 'original' : 'translation';
          btn.textContent = original ? btn.dataset.translation : btn.dataset.original;
          clamp();
        }, { signal: signal });
      });

      var observer = new ResizeObserver(clamp);
      observer.observe(track);
      signal.addEventListener('abort', function () { observer.disconnect(); });
      clamp();
    }

    var controllers = new WeakMap();
    function mount(scope) {
      scope.querySelectorAll(SELECTOR).forEach(function (root) {
        if (controllers.has(root)) return;
        var controller = new AbortController();
        controllers.set(root, controller);
        init(root, controller.signal);
      });
    }
    function unmount(scope) {
      scope.querySelectorAll(SELECTOR).forEach(function (root) {
        var controller = controllers.get(root);
        if (controller) controller.abort();
        controllers.delete(root);
      });
    }
    mount(document);
    document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { unmount(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
